import { v4 as uuid } from 'uuid';

/**
 * Lê o cronograma colado do edital (a tabela do anexo copiada do PDF) e devolve
 * as etapas com datas ISO. O mesmo cálculo serve ao editor ("Colar o
 * cronograma") e à carga dos editais já publicados.
 *
 * - Nome quebrado em várias linhas: as linhas sem data se juntam à próxima
 *   linha com data.
 * - Datas no fim da linha: "21/10", "21/10/2026", "22 a 24/10", "28/10 a 01/11",
 *   "14 e 15/11", "28/10/2026 – 01/11/2026", "até 05/11".
 * - Sem ano, vale o ano-base; se o mês volta (dezembro -> janeiro), o ano vira.
 * - Linhas de cabeçalho (começando por "Cronograma" ou "Atividades", ou com "Datas prováveis") zeram
 *   o nome em formação; o que sobra sem data no fim vai para `ignoradas`.
 */

const D = '(\\d{1,2})(?:/(\\d{1,2}))?(?:/(\\d{2,4}))?';
const DATAS = new RegExp(
  `(?:\\b(?:até|ate)\\s+)?${D}(?:\\s*(?:\\ba\\b|\\be\\b|–|—|-|\\baté\\b)\\s*${D})?\\s*$`,
  'i',
);
const CABECALHO =
  /^\s*cronograma\b|^\s*atividades?\b|datas\s+prov[áa]veis|^\s*etapas?\s*$/i;

const doisDigitos = (n) => String(n).padStart(2, '0');

export const lerCronograma = (
  texto = '',
  anoBase = new Date().getFullYear(),
) => {
  const etapas = [];
  let pendente = [];
  let ano = anoBase;
  let ultimoMes = 0;

  const dataIso = (dia, mes, anoExplicito) => {
    if (anoExplicito) {
      ano =
        anoExplicito.length === 2
          ? 2000 + Number(anoExplicito)
          : Number(anoExplicito);
    } else if (ultimoMes && Number(mes) < ultimoMes) {
      ano += 1;
    }
    ultimoMes = Number(mes);
    return `${ano}-${doisDigitos(mes)}-${doisDigitos(dia)}`;
  };

  texto.split(/\r?\n/).forEach((bruta) => {
    const linha = bruta.replace(/\s+/g, ' ').trim();
    if (!linha) return;
    if (CABECALHO.test(linha)) {
      pendente = [];
      return;
    }
    const m = linha.match(DATAS);
    // precisa de mês na primeira data ou na segunda ("22 a 24/10")
    const valida = m && (m[2] || m[5]);
    if (!valida) {
      pendente.push(linha);
      return;
    }
    const [, d1, m1, a1, d2, m2, a2] = m;
    let inicio;
    let fim;
    if (d2) {
      const mesInicio = m1 || m2;
      inicio = dataIso(d1, mesInicio, a1 || (!m1 ? a2 : undefined));
      fim = dataIso(d2, m2 || m1, a2);
    } else {
      inicio = dataIso(d1, m1, a1);
      fim = inicio;
    }
    const nome = [...pendente, linha.slice(0, m.index)]
      .join(' ')
      .replace(/\s+/g, ' ')
      .replace(/[\s:–—-]+$/, '')
      .trim();
    pendente = [];
    if (nome) etapas.push({ '@id': uuid(), nome, inicio, fim });
  });

  return { etapas, ignoradas: pendente };
};

// A etapa de inscrição alimenta o prazo principal do bloco.
export const etapaDeInscricao = (etapas = []) =>
  etapas.find((e) => /inscri/i.test(e.nome || '')) || null;
